import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/10 py-12" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <span className="font-display text-sm tracking-wide text-foreground/80">
        MOTOR<span className="text-primary">LEGENDS</span>MEDIA
      </span>
      <p className="text-[11px] uppercase tracking-[0.25em] text-foreground/40">
        Independent e-book publisher — written at redline
      </p>
      <Link to="/admin" className="text-[11px] uppercase tracking-[0.25em] text-foreground/40 hover:text-primary transition-colors duration-300" data-testid="footer-admin-link">
        Admin
      </Link>
    </div>
  </footer>
);
